import { Box, Button, CircularProgress, Divider, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Typography, makeStyles } from '@material-ui/core';
import { RemoveCircle } from '@material-ui/icons';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import { calculatePayment } from 'services/payments.service';
import { useUpdateEffect } from 'usehooks-ts';
import { localizeCurrency } from 'util/localizeFormat';
import { toasterror } from 'util/toasterror';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative'
  },
  header: {
    padding: theme.spacing(.5),
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: theme.zIndex.tooltip + 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'

  },
  footer: {
    position: 'sticky',
    bottom: 0
  }
}));
const SelectedServiceList = ({
  booking,
  promo,
  onRemove = (service) => { },
  selectedServices = [],
  onConfirm = () => { }
}) => {
  const classes = useStyles()

  const [loading, setLoading] = useState(false);
  const [calculatedTransaction, setCalculatedTransaction] = useState(null);
  const calculateTransaction = useCallback(
    async (newPackageItems) => {
      setLoading(true)
      setCalculatedTransaction(null)
      const promoParams = {
        "code": promo?.code,
        "code_type": promo?.type,
      }
      const adjustTransactionIds = {
        extended_package_items: newPackageItems?.map(servicePackage => {
          return servicePackage?.item?.id
        })
      }
      const params = {
        ...promo ? promoParams : null,
        "address": booking?.user_location?.address,
        "notes": booking?.user_location?.notes,
        "lng": booking?.longitude,
        "client_type": "web",
        "lat": booking?.latitude,
        "location_id": booking?.user_location?.id,
        "booking_option": booking?.booking_option,
        "type": booking?.type?.id,
        "service_addon_order": booking?.service_addon_order,
        "extended_package_items": booking?.extended_package_items?.map(item => item?.item?.id),
        "extended_packages": booking?.extended_packages?.map(item => item?.package?.id),
        "packages": booking?.packages,
        "options": booking?.booking_options?.map(item => item?.id),
        "duration": booking?.duration,
        "wlp_id": booking?.white_label_partner?.id,
        "white_label_customer": booking?.white_label_customer?.id,
        ...adjustTransactionIds
      }

      try {
        const results = await calculatePayment(booking?.client?.id, params)
        setCalculatedTransaction(results?.total)
      } catch (error) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details)
      } finally {
        setLoading(false)
      }


    },
    [booking, selectedServices, promo],
  );

  useEffect(
    () => {
      calculateTransaction(selectedServices)
    }, [selectedServices]
  );

  const renderCalculatedPrices = useMemo(
    () => {
      if (loading) {
        return <CircularProgress size={15} color="inherit" />
      }
      if (!isNaN(calculatedTransaction)) {
        return <Typography variant='body2' color='inherit'>
          {localizeCurrency(calculatedTransaction)}
        </Typography>
      }
    }, [loading, calculatedTransaction]
  );


  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography variant='body2'>Selected Services</Typography>
        {renderCalculatedPrices}
      </div>
      <List>
        {
          selectedServices?.filter(service => {
            return service?.showInCart
          })?.map((service, index) => {
            return (
              <ListItem key={index}
                button
                onClick={() => {
                  if (service?.item?.is_white_label_covered) {
                    return
                  }
                  onRemove(service)
                }}
              >
                <ListItemText
                  primary={<Typography variant="body2">
                    {service?.item?.label}
                  </Typography>
                  }
                  secondary={
                    <Typography variant="caption">
                      {localizeCurrency(service?.item?.fee)}
                    </Typography>
                  }
                />
                <Typography variant='caption' color='textSecondary'>{service?.item?.is_white_label_covered ? '' : 'not covered'}</Typography>

                {
                  service?.item?.is_white_label_covered ? null :
                    (
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => {
                          // trackEvent('Cart - Remove Service', { service: service?.label })
                          // onRemove(service)
                        }}
                      >
                        <RemoveCircle color='primary' />
                      </IconButton>
                    )
                }

              </ListItem>
            )
          })}
      </List>
      <Button
        className={classes.footer}
        fullWidth
        size="small"
        variant="contained"
        color="secondary"
        disabled={selectedServices?.length <= 0}
        onClick={() => {
          onConfirm()
        }}
      >
        Confirm Selection
      </Button>
    </div>
  )
}

export { SelectedServiceList }